/* ============================================================
   Falconclaw pagev2 - fc2-kit (kit builder) toggling.
   All markup is pre-rendered by sections/fc2-kit.liquid; this file
   ONLY toggles which config card is active and which parts panel is
   visible. Cards are role=button divs (M11): Enter/Space activate.
   Failure mode: any runtime error logs '[fc2-kit]' and reveals
   ALL panels statically, so content is never lost.

   2026-08-11 (wave 3) - DIRECT QUICK ADD. On a card the section has
   marked .fc2-kit__cardbox[data-fc-qa] (see the safety gate in
   sections/fc2-kit.liquid), Quick add no longer opens Impact's
   quick-buy drawer. It writes the colour the customer picked ON THE
   CARD into that card's hidden <form is="product-form"> and calls
   requestSubmit(), i.e. it hands over to the THEME's own add-to-cart:
   ProductForm._onSubmit posts /cart/add.js and dispatches variant:add,
   and CartDrawer._onVariantAdded answers that with show(). Nothing here
   fetches, and nothing here touches the cart drawer's DOM.
   Impact binds the drawer trigger with new Delegate(document.body),
   i.e. on BODY in the bubble phase, so a capture-phase listener on
   document that calls stopPropagation() is enough to keep the popup
   shut; the drawer element stays in the markup purely as the fallback
   if this file ever fails to load.
   ============================================================ */
(function () {
  'use strict';

  function fallback(root, err) {
    try {
      Array.prototype.forEach.call(root.querySelectorAll('.fc2-kit__panel'), function (p) {
        p.classList.add('fc2-kit__panel--open');
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-fc2-kit-toggle]'), function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
    } catch (e2) { /* nothing safe left to do */ }
    if (window.console) console.warn('[fc2-kit] fallback to static panels:', err);
  }

  function boot() {
    var root = document.getElementById('fc2-kit');
    if (!root || root.dataset.fc2KitInit === '1') return;
    root.dataset.fc2KitInit = '1';
    try {
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fc2-kit-toggle]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('.fc2-kit__panel'));
      var cardsWrap = root.querySelector('.fc2-kit__configs');
      if (!cards.length || !panels.length) return;

      function colCount() {
        try {
          var t = cardsWrap ? getComputedStyle(cardsWrap).gridTemplateColumns : '';
          var n = t ? t.split(' ').filter(function (s) { return s && s !== 'none'; }).length : 1;
          return n > 0 ? n : 1;
        } catch (e) { return 1; }
      }
      /* 2026-06-15b: place the open panel on the grid row directly AFTER the clicked
         card's WHOLE row, full-width (grid-column:1/-1 in CSS), so every card stays
         visible in its row instead of being shoved below the tall panel (round-1
         regression: an interleaved panel opened right under one card and pushed its
         row-mates off-screen). */
      function placePanel(panel, idx) {
        try {
          var row = Math.floor((parseInt(idx, 10) || 0) / colCount());
          panel.style.gridRow = (row + 2) + ' / span 1';
        } catch (e) { panel.style.gridRow = ''; }
      }

      function activate(card) {
        try {
          var i = card.getAttribute('data-fc2-kit-toggle');
          var wasOpen = card.getAttribute('aria-expanded') === 'true';
          cards.forEach(function (c) {
            c.setAttribute('aria-expanded', 'false');
            c.classList.remove('fc2-kit__config--on');
          });
          panels.forEach(function (p) { p.classList.remove('fc2-kit__panel--open'); p.style.gridRow = ''; });
          if (cardsWrap) cardsWrap.classList.remove('fc2-kit__configs--active');
          if (!wasOpen) {
            card.setAttribute('aria-expanded', 'true');
            card.classList.add('fc2-kit__config--on');
            if (cardsWrap) cardsWrap.classList.add('fc2-kit__configs--active');
            var panel = document.getElementById('fc2-kit-panel-' + i);
            if (panel) { placePanel(panel, i); panel.classList.add('fc2-kit__panel--open'); }
          }
        } catch (err) { fallback(root, err); }
      }

      cards.forEach(function (card) {
        card.addEventListener('click', function () { activate(card); });
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            activate(card);
          }
        });
      });

      /* re-place the open panel if the column count changes across a breakpoint */
      window.addEventListener('resize', function () {
        try {
          var on = root.querySelector('.fc2-kit__config--on');
          if (!on) return;
          var idx = on.getAttribute('data-fc2-kit-toggle');
          var panel = document.getElementById('fc2-kit-panel-' + idx);
          if (panel) placePanel(panel, idx);
        } catch (e) { /* non-fatal */ }
      }, { passive: true });
    } catch (err) { fallback(root, err); }
  }

  /* ---------------------------------------------------------------
     Quick add -> straight to cart (2026-08-11, wave 3)
     --------------------------------------------------------------- */

  /* The variant the customer chose ON THE CARD. Impact's
     ProductCard._onSwatchChanged rewrites the card's product links to
     ...?variant=<id> on every swatch change, so the href is the live
     answer. Before the first swatch click there is no ?variant= yet, so
     fall back to the checked swatch radio, then to whatever the section
     server-rendered into the form. */
  function chosenVariantId(box) {
    var link = box.querySelector('a[href*="/products/"][href*="variant="]');
    if (link) {
      var m = /[?&]variant=(\d+)/.exec(link.getAttribute('href') || '');
      if (m) return m[1];
    }
    var radio = box.querySelector('input[type="radio"][data-variant-id]:checked');
    return radio ? radio.getAttribute('data-variant-id') : null;
  }

  function onQuickAdd(e) {
    try {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var t = e.target;
      if (!t || !t.closest) return;
      /* both Quick add triggers (desktop button + mobile cart icon) carry
         aria-controls="quick-buy-<section>-<product>" */
      var trigger = t.closest('[aria-controls^="quick-buy-"]');
      if (!trigger) return;
      var box = trigger.closest('.fc2-kit__cardbox[data-fc-qa]');
      if (!box) return;
      var form = box.querySelector('form.fc2-kit__qa-form');
      var input = form && form.querySelector('input[name="id"]');
      /* anything missing: do nothing at all, so the stock drawer still opens */
      if (!form || !input || typeof form.requestSubmit !== 'function') return;

      var vid = chosenVariantId(box);
      if (vid) input.value = vid;

      e.preventDefault();
      e.stopPropagation();
      form.requestSubmit();
    } catch (err) {
      if (window.console) console.warn('[fc2-kit] quick add:', err);
    }
  }

  /* document-level delegation, capture phase, bound exactly once even
     though Impact's instant-nav can re-run this file on a soft
     navigation (the flag lives on <html>, not on window) */
  if (document.documentElement.dataset.fc2KitQuickAdd !== '1') {
    document.documentElement.dataset.fc2KitQuickAdd = '1';
    document.addEventListener('click', onQuickAdd, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
